import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    alias: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/Register.vue')
  },
  {
    path: '/register-success',
    name: 'RegisterSuccess',
    component: () => import('../views/RegisterSuccess.vue')
  },
  {
    path: '/logout',
    name: 'Logout',
    component: () => import('../views/Logout.vue')
  },
  {
    path: '/findpwd',    
    component: () => import('../views/findpwd/Findpwd.vue'),
    children: [    
      {
        path: '',
        alias: 'seletctmethod',
        name: 'FindpwdSelectMethod',
        component: () => import('../views/findpwd/SelectMethod.vue')
      },
      {
        path: 'byorder',
        alias: 'byorder',
        name: 'FindpwdByOrder',
        component: () => import('../views/findpwd/ByOrder.vue')
      },
      {
        path: 'byphone',
        alias: 'byphone',
        name: 'FindpwdByPhone',
        component: () => import('../views/findpwd/ByPhone.vue')
      },
      {
        path: 'confirmusername',
        name: 'ConfirmUsername',
        component: () => import('../views/findpwd/ConfirmUsername.vue')
      },
      {
        path: 'verify',
        name: 'FindPwdVerify',
        component: () => import('../views/findpwd/Verify.vue')
      },
      {
        path: 'reset',
        name: 'FindPwdReset',
        component: () => import('../views/findpwd/Reset.vue')
      },
      {
        path: 'success',
        name: 'FindPwdSuccess',
        component: () => import('../views/findpwd/Success.vue')
      }
    ]
  },
  {
    path: '/servicerule',
    name: 'ServiceRule',
    component: () => import('../views/ServiceRule.vue')
  },
  {
    path: '/usercenter',
    name: 'UserCenter',
    component: () => import('../views/usercenter/Index.vue'),
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/bindmobile',
    name: 'BindMobile',
    component: () => import('../views/usercenter/BindMobile.vue'),
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/verify',
    name: 'Verify',
    component: () => import('../views/usercenter/Verify.vue'),
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/setpassword',
    name: 'SetPassword',
    component: () => import('../views/usercenter/SetPassword.vue'),
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/bindmail',
    name: 'BindMail',
    component: () => import('../views/usercenter/BindMail.vue'),
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/loginrecord',
    name: 'LoginRecord',
    component: () => import('../views/usercenter/LoginRecord.vue'),
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/history',
    name: 'History',
    component: () => import('../views/usercenter/History.vue'),
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/Favlist',
    name: 'Favlist',
    component: () => import('../views/usercenter/Favlist.vue'),
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/cards',
    name: 'Cards',
    component: () => import('../views/usercenter/Cards.vue'),
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/orders',
    name: 'Orders',
    component: () => import('../views/usercenter/Orders.vue'),
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/second-confirm',
    name: 'SecondConfirm',
    component: () => import('../views/usercenter/SecondConfirm.vue'),
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/refresh',
    name: 'Refresh',
    component: () => import('../views/Refresh.vue')
  },
  {
    path: '*',
    component: () => import('../views/404.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) {
    // 判断是否需要登录
    if (store.getters['user/loginState']) {
      next()
    } else {
      next({
        name: 'Login',
        query: {
          redirect: top.window.location.protocol + '//' + top.window.location.host + to.fullPath
        } // 将跳转的路由path作为参数，登录成功后跳转到该路由
      })
    }
  } else {
    next()
  }
})

export default router
